import React from 'react'

import { cloneDeep } from 'lodash'

import { Button, Box, CircularProgress, Skeleton } from '@mui/material'

import MuiForm from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'

import transformErrorsFactory from './components/transformErrorsFactory'

import propTypes from './MaterialJSONSchemaForm.propTypes'
import defaultProps from './MaterialJSONSchemaForm.defaultProps'

function BotInput(props) {
return (<Box
        sx={{
          position: "absolute",
          left: "-9999px",
          width: "1px",
          height: "1px",
          overflow: "hidden",
        }}
        aria-hidden="true"
      >
        <label htmlFor={props.id}>Company website</label>
        <input
          id={props.id}
          name={props.name}
          type="text"
          tabIndex={-1}
          autoComplete="off"
        />
      </Box>)
}

class MaterialJSONSchemaForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {};
    if(!props.noCaptcha) {
      fetch('/api/recaptcha-token')
        .then((res) => res.json())
        .then((data) => this.setState({recapatchaToken: data.token}))
        .catch(() => this.setState({recapatchaToken: null}));
    }
  }

  render () {
    const {
      schema,
      uiSchema,
      disabled,
      customErrors,
      noSubmit,
      noCaptcha,
      ...others
    } = this.props

    const finalSchema = cloneDeep(schema || {})
    const finalUISchema = cloneDeep(uiSchema || {})
    const finalCustomErrors = cloneDeep(customErrors || {})
    // let formExtras = null;
    if (!noCaptcha) {

      if(!this.state.recapatchaToken) {
        return (<Box><Skeleton variant='rectangular' sx={{width: '100%', height: '2rem'}} />
          <Skeleton variant='rectangular' sx={{width: '100%', height: '10rem', pt:1}} />
        </Box>)
      }

      finalSchema.required = finalSchema.required || []
      finalSchema.required.push('recaptcha')
      finalSchema.properties.recaptcha = {
        type: 'string',
        title: 'ReCaptcha',
        default: this.state.recapatchaToken
      }
            finalUISchema.recaptcha = {
        'ui:widget': 'hidden'
      }

      finalSchema.properties.company_website = {
        'type': 'string',
        'title': 'Company Website'
      }

      finalUISchema.company_website = {
        'ui:widget': BotInput
      }
    }

    return (
      <MuiForm
        disabled={disabled}
        transformErrors={transformErrorsFactory({
          schema: finalSchema,
          customErrors: finalCustomErrors
        })}
        schema={finalSchema}
        uiSchema={finalUISchema}
        validator={validator}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...others}
      >
        {/* {formExtras} */}
        <Box>
          {!noSubmit && (
            <Button
              disabled={disabled}
              variant='contained'
              fullWidth
              color='primary'
              type='submit'
            >
              Submit
            </Button>
          )}
        </Box>
      </MuiForm>
    )
  }
}

MaterialJSONSchemaForm.propTypes = propTypes
MaterialJSONSchemaForm.defaultProps = defaultProps

export default MaterialJSONSchemaForm
